<template>
  <div>
    <div style="margin-left: 10px">
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        "
      >
        <div class="logos">
          <img
            src="../../../../assets//images/fondo-pefil.png"
            style="width: 90px"
          />
          <img
            src="../../../../assets//images/logos/Rabey-logo-w.png"
            style="width: 90px"
          />
        </div>
        <h3 style="margin-right: 10px">
          Activos del empleado {{ employeeName }}
        </h3>
      </div>
      <h3>Fecha de entrega {{ date }}</h3>
    </div>

    <div style="margin-top: 50px">
      <el-table :data="data" style="width: 100%">
        <el-table-column prop="Description" label="Descripcion" width="220">
        </el-table-column>
        <el-table-column
          prop="ResponsibleEmployee"
          label="Cod. Responsable"
          width="136"
        >
        </el-table-column>
        <el-table-column
          prop="ResponsibleEmployeeName"
          label="Nom. Responsable"
          width="150"
        >
        </el-table-column>
        <el-table-column prop="FaSubClassCode" label="Clase" width="100">
        </el-table-column>
        <el-table-column
          prop="LastDateModified"
          label="F. Asignacion"
          width="110"
        >
        </el-table-column>
        <el-table-column prop="SerialNo" label="Serial" width="110">
        </el-table-column>
      </el-table>
    </div>
    <div
      style="
        margin: 40px 10px 0 10px;
        display: flex;
        flex-direction: column;
        gap: 12px;
      "
    >
      <p style="margin-bottom: 30px">
        <strong
          >Las Herramientas Suministradas para la realización de sus
          labores</strong
        >
        durante la prestación del servicio, son propiedad de
        <strong>TENNOS BUSINESS SRL Y/O RABBEY TECHNOLOGIES SRL</strong>,
        comprometiéndose usted a hacer buen uso de ellas y a devolverlas en buen
        estado a dicha entidad al concluir el contrato laboral. Así mimo, EL
        TRABAJADOR autoriza a EL EMPLEADOR, que en caso de que se prescinda de
        sus servicios y quede rescindido el contrato de trabajo, éste descuente
        de las prestaciones laborales que le corresponda el monto
        correspondiente por motivo de daños, robo o perdidas de las herramientas
        suministradas. Firmando EL TRABAJADOR este documento sin ninguna
        reserva.
      </p>

      <br />
      <el-form-item>
        <el-row :gutter="20">
          <el-col :span="5">
            <div style="width: 220px; color: black; text-align: center">
              <hr />
              <h4>Recursos Humano</h4>
            </div>
          </el-col>
          <el-col :span="6"
            ><div class="grid-content bg-purple">ㅤ</div></el-col
          >
          <el-col :span="6">
            <div style="width: 220px; color: black; text-align: center">
              <hr />
              <h4>Empleado</h4>
            </div>
          </el-col>
        </el-row>
      </el-form-item>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date: ""
    };
  },
  props: {
    employeeName: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  methods: {
    dateTime() {
      const dateTime = new Date();
      this.date = `${dateTime.getDate()}/${
        dateTime.getMonth() + 1
      }/${dateTime.getFullYear()}`;
      console.log(this.date);
    }
  },
  created() {
    this.dateTime();
  }
};
</script>
